<template>
    <div style="display: flex; flex-direction: column;">
        <div class="dashboard-item-title-div" style="display:flex;align-items:center;height:50px">
            <label class="dashboard-item-title-label">{{titleTxt}}</label>
            <button @click="registerBtn_click" class="css-button flat-button-gray" style="margin-left:auto" type="button" :title="registerBtnTitle">Register EPCS Signer App</button>
        </div>
        <div v-show="!error && !collected && !collecting" style="width:800px;height:200px;display:flex;justify-content:space-around;align-items:center;align-self:center;">
            <button @click="collectBtn_click" class="css-button flat-button-blue" type="button">{{collectBtnTxt}}</button>
            <button @click="skipBtn_click" class="css-button flat-button-red" type="button">{{skipBtnTxt}}</button>
        </div>
        <div v-show="!error && !collected && collecting" style="display:flex;align-items:center;flex-flow:column;height:200px;justify-content:space-around">
            <div style="display:flex;align-items:center;flex-flow:row;width:400px">
                <div style="min-width:50px" class="ajax-loading"></div>
                <h1>{{collectingTxt}}</h1>
            </div>
            <button @click="skipBtn_click" class="css-button flat-button-red" type="button">{{skipBtnTxt}}</button>
        </div>
        <div v-show="!error && collected" style="display:flex;align-items:center;flex-flow:column;height:200px;justify-content:space-around">
            <svg width="48px" height="48px" fill="green">
                <use xlink:href="/App_Themes/default1/icons/sapphire-svg-sprites.svg#confirmFilledIcon" />
            </svg>
            <div style="display:flex;align-items:center;flex-flow:row;width:400px">
                <div style="min-width:50px" class="ajax-loading"></div>
                <h1>{{successTxt}}</h1>
            </div>
            <button @click="skipBtn_click" class="css-button flat-button-blue" type="button">Continue to landing page</button>
        </div>
        <div v-show="error" style="display:flex;align-items:center;flex-flow:column;height:200px;justify-content:space-around">
            <svg width="48px" height="48px" fill="red">
                <use xlink:href="/App_Themes/default1/icons/sapphire-svg-sprites.svg#urgentIcon" />
            </svg>
            <h1 style="margin-bottom:10px">There was a problem collecting your token. Please retry or contact your administrator.</h1>
            <div style="width:400px;display:flex;justify-content:space-around;align-items:center;align-self:center;">
                <button @click="retryBtn_click" class="css-button flat-button-blue" type="button">{{retryBtnTxt}}</button>
                <button @click="skipBtn_click" class="css-button flat-button-red" type="button">{{skipBtnTxt}}</button>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    //Import jQuery
    // import $ from 'jquery'

    export default {
    name: "collectEpcsSerialNumber",
    props: {
     },
    data: function () {
        return {
            collectionType: '',
            returnUrl: '',
            signerUrl: '',
            collected: false,
            collecting: false,
            error: false,
            registerBtnTitle: 'If the EPCS Signer App is not opening, use this button to install.',
            retryCancel: null,
            userID: '',
            waitTimeInMinutes: 1
        }
    },
    computed: {
        collectBtnTxt: function () {
            var vm = this;
            if (vm.isAssociationType)
                return 'Associate your EPCS token with this account';
            else
                return 'Verify your EPCS token';
        },
        collectingTxt: function () {
            var vm = this;
            if (vm.isAssociationType)
                return 'Please associate your token by clicking ASSOCIATE in the recently launched Sapphire EPCS Signer.';
            else
                return 'Please verify your token by clicking VERIFY in the recently launched Sapphire EPCS Signer.';
        },
        isAssociationType: function () {
            return (this.collectionType == 'associate');
        },
        isVerifyType: function () {
            return (this.collectionType == 'verify');
        },
        retryBtnTxt: function () {
            var vm = this;
            if (vm.isAssociationType)
                return 'Retry Association';
            else
                return 'Retry Verification';
        },
        skipBtnTxt: function () {
            var vm = this;
            if (vm.isAssociationType)
                return 'Skip token association for now';
            else
                return 'Skip token verification for now';
        },
        successTxt: function () {
            var vm = this;
            if (vm.isAssociationType)
                return 'Your token was successfully associated with this account. You will be redirected to your landing page.';
            else
                return 'Your token was successfully verified. You will be redirected to your landing page.';
        },
        titleTxt: function () {
            var vm = this;
            if (vm.isAssociationType)
                return 'Associate EPCS Token';
            else
                return 'Verify EPCS Token';
        },
        useType: function () {
            var vm = this;
            if (vm.isAssociationType)
                return 4;
            else
                return 5;
        },
        waitMethodCall: function () {
            var vm = this;
            if (vm.isAssociationType)
                return 'HasEPCSSerialNumber';
            else
                return 'IsEPCSVerified';
        }
    },
    mounted: function () {
        this.init();
    },
    watch: {
        collected: function (newVal) {
            this.collected_watch(newVal);
        }
    },
    methods: {
        init: function () {
            var vm = this;
            vm.getUserID();
        },
        collectBtn_click: function () {
            var vm = this;
            vm.collecting = true;
            vm.generateAndNavigateToLink();
            vm.waitForSign();
        },
        collected_watch: function (collectedNewVal) {
            var vm = this;
            if (collectedNewVal) {
                window.setTimeout(function () {
                    vm.goToReturnUrl();
                }, 5000);
            }
        },
        generateAndNavigateToLink() {
            var vm = this;
            axios.post("../../Common/Services/EmarClientOperations.svc/generateOTP")
            .then((response) => {
                let otp = response.data.d.replace('"', '');
                window.location.href = 'sapphireepcssignerxam://uri/?useType=' + vm.useType + '&u=' + vm.userID + '&otp=' + otp + '&source=' + window.location.host;
            })
            .catch(function () {
                // handle error
                vm.$swal({
                    title: "Error #V5AW-PYSK", 
                    text: "An error occurred generating SapphireEPCSSigner link. Please retry.", 
                    icon: "error"});
                vm.error = true;
            });
         },
        goToReturnUrl: function () {
            var vm = this;
            window.location.href = '../..' + vm.returnUrl.replace('~', '');
        },
        getUserID() {
            var vm = this;
            axios.post("../../Common/Services/EmarClientOperations.svc/getUserID")
            .then((result) => {
                vm.userID = result.data.d;
            })
            .catch(function () {
                // handle error
                vm.$swal({
                    title: "Error #4FYC-XNLW", 
                    text: "An error occurred retrieving user ID. Please retry.", 
                    icon: "error"});
                vm.error = true;
            });
           
        },
        registerBtn_click: function () {
            var installUrl = window.location.protocol + '//' + window.location.host + '/Common/Apps/SapphireEPCSSigner/Install/index.html';
            window.open(installUrl, '_blank');
        },
        retryBtn_click: function () {
            var vm = this;
            vm.error = false;
            vm.collecting = true;
            vm.waitForSign(null, null, vm.generateAndNavigateToLink);
        },
        skipBtn_click: function () {
            var vm = this;
            vm.goToReturnUrl();
        },
        waitForSign: function (c, v, callbackIfFirstCheckNotTrue) {
            var vm = v || this;
            var counter = c || 0;
            if (counter > (vm.waitTimeInMinutes * 20)) {
                vm.error = true;
                return;
            }
            window.setTimeout(function () {
                axios.post("../../Common/Services/EmarClientOperations.svc/" + vm.waitMethodCall, {
                    userID: vm.userID
                })
                .then((response) => {
                    // handle success
                    if (response.data.d == 'true') {
                        vm.collected = true;
                    } else {
                        if (callbackIfFirstCheckNotTrue && counter == 0) {
                            callbackIfFirstCheckNotTrue();
                        }
                        counter++;
                        vm.waitForSign(counter, vm);
                    }
                })
                .catch(function () {
                    // handle error
                    vm.$swal({
                        title: "Error #DWM8-TXTP", 
                        text: "An error occurred with (" + vm.waitMethodCall + "). Please retry.", 
                        icon: "error"});
                });
            }, 3000)
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
</style>